import type { ImageTypes } from 'fitify-ui-landing/src/@types'

const headerImages: {
  mainImage: ImageTypes.Header
  slideshowImages: ImageTypes.Header[]
} = {
  mainImage: {
    headerImage: '/assets/images/hero/{{language}}/hero-main@2x.webp',
    headerImageSet:
      '/assets/images/hero/{{language}}/hero-main.webp 600w, /assets/images/hero/{{language}}/hero-main@2x.webp 2x, /assets/images/hero/{{language}}/hero-main@2x.webp 1200w',
  },
  slideshowImages: [
    {
      headerImage: '/assets/images/hero/hero1@2x.webp',
      headerImageSet:
        '/assets/images/hero/hero1.webp 600w, /assets/images/hero/hero1@2x.webp 2x, /assets/images/hero/hero1@2x.webp 1200w',
    },
    {
      headerImage: '/assets/images/hero/hero2@2x.webp',
      headerImageSet:
        '/assets/images/hero/hero2.webp 600w, /assets/images/hero/hero2@2x.webp 2x, /assets/images/hero/hero2@2x.webp 1200w',
    },
    {
      headerImage: '/assets/images/hero/hero3@2x.webp',
      headerImageSet:
        '/assets/images/hero/hero3.webp 600w, /assets/images/hero/hero3@2x.webp 2x, /assets/images/hero/hero3@2x.webp 1200w',
    },
  ],
}

export { headerImages }
